export const DefaultIPLocation = {
  'country_code': 'IN',
  'country_name': 'India',
  'city_name': 'Mumbai',
  'region_name': 'Maharashtra',
  'latitude': 19.0144100189209,
  'longitude': 72.84793853759766,
  'zip_code': '400099'
};
